<template>
  <v-container
    text-xs-center
    class="pt-5 px-4"
  >
    <v-toolbar
      flat
      height="43px"
      color="#140C22"
      class="navigation-toolbar"
    >
      <v-layout
        row
        wrap
        align-center
      >
        <v-flex
          xs4
          style="text-align: start;"
        >
          <v-btn
            flat
            icon
            class="change-route-btn"
            block
            color="#fff"
            @click="backToProducts"
          >
            <v-icon class="mr-2 mb-1">
              $vuetify.icons.arrowLeftIcon
            </v-icon>
            Voltar
          </v-btn>
        </v-flex>
        <v-flex
          xs8
          style="text-align: end;"
        >
          <v-btn
            v-show="catalogueProductCount"
            flat
            icon
            class="change-route-btn"
            block
            color="#fff"
            @click="addToCatalogue"
          >
            Finalizar seleção
            <v-icon class="ml-2 mb-1">
              $vuetify.icons.arrowRightIcon
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-toolbar>

    <v-card
      v-if="!enterLoading"
      flat
      class="mx-2 animated fadeIn delay-1s"
    >
      <v-layout
        row
        wrap
        class="mt-4"
        align-center
      >
        <v-flex
          xs12
          class="catalogue-select text-xs-left mb-3"
        >
          Você está personalizando:
        </v-flex>

        <v-flex
          xs10
          class="catalogue-select__catalogue-name"
        >
          {{ personalizeHeader.title }}
        </v-flex>

        <v-flex
          xs2
          class="text-xs-right"
        >
          <v-badge
            right
            overlap
            color="#FFADDE"
            :value="catalogueProductCount"
          >
            <template #badge>
              <span>
                {{ catalogueProductCount }}
              </span>
            </template>
            <v-btn
              depressed
              :disabled="!catalogueProductCount"
              color="#140C22"
              class="catalogue-product-count ma-0"
              @click="addToCatalogue"
            >
              <v-icon color="#fff">
                $vuetify.icons.catalogueIcon
              </v-icon>
            </v-btn>
          </v-badge>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="search"
        align-center
      >
        <v-flex
          align-self-left
          xs9
        >
          <v-combobox
            ref="combobox"
            v-model="catalogueFilters"
            append-icon="mdi-chevron-down"
            :items="allFilters"
            :menu-props="{
              closeOnContentClick: true
            }"
            dense
            small-chips
            clearable
            deletable-chips
            hide-selected
            label="Buscar produto, setor ou categoria"
            multiple
            no-data-text="Nenhum resultado encontrado..."
            @change="reset"
          />
        </v-flex>
        <v-flex
          xs3
          style="text-align: end;"
        >
          <v-btn
            depressed
            outline
            color="#140C22"
            class="barcode ma-0 px-0"
            @click="openCamera"
          >
            <v-icon
              small
              color="primary"
            >
              $vuetify.icons.barCodeScanner
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="order-by__txt"
        align-center
      >
        <v-flex
          xs6
          class="order-by__select-btn"
          style="text-align: start;"
        >
          <v-btn
            id="personalize"
            depressed
            class="catalogue-select__personalize secondary-btn ml-0"
            color="#140C22"
            @click="selectAll"
          >
            <span style="text-transform: capitalize">
              + Selecionar Todos
            </span>
          </v-btn>
        </v-flex>
        <v-flex
          class="order-arrows"
          xs4
        >
          <span class="order-by__arrows mr-1">
            ↑↓
          </span>
          <span>
            Ordenar por:
          </span>
        </v-flex>
        <v-flex
          xs2
          class="order-by__select-order"
        >
          <v-select
            v-model="catalogueSortAsc"
            :items="sort"
            item-text="label"
            append-icon=""
            filled
            :menu-props="{ bottom: true, offsetY: true }"
            dense
          >
            <template #selection="{ item }">
              <span class="order-by__select">
                {{ item.label }}
              </span>
            </template>
            <template #item="{ item }">
              <v-list-tile-content class="order-by__select">
                {{ item.label }}
              </v-list-tile-content>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        justify-space-around
        class="mb-5 pb-2"
      >
        <v-flex
          v-for="(product, index) in filteredProducts"
          :key="product.sku"
          xs6
          md3
        >
          <vue-intersect @enter="setProductVisible(index)">
            <ProductCard
              :product="product"
              :open-zero-stock-dialog="openZeroStockDialog"
              can-select
              is-personalize
              :store="store"
            />
          </vue-intersect>
        </v-flex>
      </v-layout>

      <div style="margin-bottom: 150px">
        <infinite-loading
          ref="infiniteLoading"
          spinner="spiral"
          force-use-infinite-wrapper
          @infinite="infiniteHandler"
        >
          <div slot="no-results">
            Sem mais resultados
          </div>
          <div slot="no-more">
            Sem mais resultados
          </div>
        </infinite-loading>
      </div>
    </v-card>
    <v-dialog
      v-if="barCodeDialog"
      v-model="barCodeDialog"
      persistent
      max-width="330"
    >
      <BarCodeDialog
        :products="products"
        @close-camera="closeCamera"
      />
    </v-dialog>
    <v-dialog
      v-model="discardDialog"
      max-width="317"
    >
      <ActionsDialog
        :dialog-text="`${sellerFirstName}, ao voltar você perderá toda a personalização deste catálogo.`"
        support-text="O que deseja fazer?"
        first-text="Continuar editando"
        second-text="Descartar edição"
        :first-action="() => { discardDialog = false }"
        :second-action="() => { $router.push('/produtos') }"
        :close="() => { discardDialog = false }"
      />
    </v-dialog>

    <v-dialog
      v-if="!enterLoading"
      v-model="maxFavoritesDialog"
      max-width="317"
    >
      <ActionsDialog
        :dialog-text="`${sellerFirstName}, você atingiu o número máximo de catálogos favoritos.`"
        support-text="Desfavorite pelo menos um catálogo para poder favoritar a sua personalização."
        first-text="Quero continuar"
        second-text="Voltar"
        :first-action="() => { maxFavoritesDialog = false }"
        :second-action="() => { $router.push('/produtos') }"
        :close="() => { maxFavoritesDialog = false }"
      />
    </v-dialog>

    <v-dialog
      v-model="zeroStockDialog"
      max-width="360"
    >
      <ZeroStockDialog
        :close="() => { zeroStockDialog = false }"
        :product-selected="productSelected"
        @change-quantity="changeQuantityZeroStock"
      />
    </v-dialog>

    <v-progress-circular
      v-if="enterLoading"
      class="progress-circular"
      size="50"
      width="4"
      color="#140C22"
      indeterminate
    />
  </v-container>
</template>

<script>
/*  eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
import { everything } from '@sejazipper/layer-api-client';
// eslint-disable-next-line import/no-unresolved
import ProductCard from '@/components/Product/ProductCard';
// eslint-disable-next-line import/no-unresolved
import ActionsDialog from '@/components/ActionsDialog';
import { mapGetters } from 'vuex';
// eslint-disable-next-line import/no-unresolved, import/extensions
import { EventBus } from '@/event-bus.js';
import VueIntersect from 'vue-intersect';
import Quagga from 'quagga';
import ZeroStockDialog from '../components/Product/ZeroStockDialog.vue';
import { FindCatalogueBySellerIdAndType } from '../apollo';
import { useZipperApi } from '../composables/useZipperApi';
import BarCodeDialog from '../components/Product/BarCodeDialog.vue';

// eslint-disable-next-line import/no-extraneous-dependencies
const _ = require('lodash');
const Wade = require('wade');

const { client } = useZipperApi();

export default {
  components: {
    ProductCard,
    ActionsDialog,
    ZeroStockDialog,
    VueIntersect,
    BarCodeDialog,
  },

  data: () => ({
    page: 0,
    size: 100,
    enterLoading: false,
    productSelected: null,
    discardDialog: false,
    maxFavoritesDialog: false,
    zeroStockDialog: false,
    awaitingSearch: false,
    allFilters: [],
    products: [],
    filters: null,
    search: null,
    selectAllProducts: false,
    totalProducts: null,
    selectingAllProducts: false,
    addingProducts: false,
    eventCatalogue: null,
    barCodeDialog: false,
    sort: [
      {
        label: 'Maior Preço',
        value: false,
      },
      {
        label: 'Menor Preço',
        value: true,
      },
    ],
    searchHeaders: {
      categories: { header: 'Categoria:' },
      sizes: { header: 'Tamanho:' },
      colors: { header: 'Cor:' },
      sectors: { header: 'Setor:' },
    },
    templateCatalogue: {},
    catalogue: {},
    loading: false,
    searchProducts: [],
    store: {},
  }),

  computed: {
    catalogueSortAsc: {
      get() {
        return this.$store.state.catalogueSortAsc;
      },
      set(value) {
        this.$store.commit('SET_CATALOGUE_SORT_ASC', value);
      },
    },

    finalProducts() {
      let { products } = this;

      if (this.catalogueFilters.length) {
        if (!this.searchProducts.length) this.handleSearch();
        products = this.searchProducts;
      }

      return products;
    },

    slicedProducts() {
      const sortedProducts = this.sortProductsBySkuPrice(this.finalProducts, this.catalogueSortAsc);

      return sortedProducts.slice(0, this.size * (this.page + 1));
    },

    filteredProducts() {
      const productsInStock = this.slicedProducts.filter((p) => (Math.max(...p.skus.map((sku) => sku.sku_prices[0].price))) > 0);
      productsInStock.forEach((product) => { product.visible = false; });

      const sortedProducts = _.orderBy(productsInStock, 'mainImage');

      return this.filterProductsSkusByTemplateCatalogue(sortedProducts);
    },

    ...mapGetters([
      'getStore',
      'getCustomer',
      'getCatalogueSortAsc',
      'getCatalogue',
      'getProfile',
      'isMaxFavoriteCatalogues',
      'getCatalogueId',
      'getProducts',
    ]),

    catalogueFilters: {
      get() {
        return this.$store.state.catalogueFilters;
      },
      async set(value) {
        this.$store.commit('SET_CATALOGUE_FILTERS', value);
      },
    },

    catalogueProductCount() {
      return this.products.filter((product) => product.checkbox).length;
    },

    sellerFirstName() {
      const names = this.getProfile.name.trim().split(' ');

      return names[0];
    },

    templateCatalogueId() {
      if (this.isCatalogue) return this.catalogue.templateCatalogueId;
      return this.getCatalogueId;
    },

    isCatalogue() {
      return this.getCatalogueId.length === 9;
    },

    personalizeHeader() {
      return {
        icon: this.isCatalogue ? '$vuetify.icons.heartOutlineIcon' : '$vuetify.icons.storeIcon',
        title: this.isCatalogue ? this.catalogue.favoriteName : this.templateCatalogue.name,
      };
    },

    catalogueIcon() {
      return this.isCatalogue
        ? '$vuetify.icons.heartOutlineIcon'
        : '$vuetify.icons.storeIcon';
    },

    searchSectors() {
      const sectors = _.uniq(this.products.map((product) => product.setor)).filter((product) => product);
      const custom = _.uniq(this.products.map((product) => product.customSector)).filter((product) => product);
      const combined = sectors.concat(custom);

      return combined;
    },
  },

  watch: {
    async catalogueFilters() {
      if (this.awaitingSearch) return;
      await this.handleSearch();
    },
    // eslint-disable-next-line no-unused-vars
    async getStore(store, _oldVal) {
      if (store) {
        this.page = 0;
        this.products = this.getProducts;
        this.store = await client.chain.query.findStoreByMongoId({
          mongoId: store.id,
        }).get({ ...everything });
      }
    },
  },
  async beforeMount() {
    this.maxFavoritesDialog = (this.isMaxFavoriteCatalogues && !this.isCatalogue);
  },

  async mounted() {
    setTimeout(() => {
      this.enterLoading = false;
    }, 500);

    this.store = await client.chain.query.findStoreByMongoId({
      mongoId: this.getStore.id,
    }).get({ ...everything });

    for (const product of this.products) {
      for (const sku of product.skus) {
        if (sku.product_type_id < 4) {
          this.$set(product, 'customSector', 'Outlet');
        }
      }
    }
  },

  methods: {
    getHighestPrice(product) {
      let maxSkuPrice = null;
      let maxPrice = -Infinity;

      product.skus.forEach((sku) => {
        const { price } = sku.sku_prices[0];

        if (price && price > maxPrice) {
          maxPrice = price;
          maxSkuPrice = sku;
        }
      });

      return maxSkuPrice;
    },

    async selectAll() {
      this.resetInfiniteLoading();
      this.$nextTick(() => {
        this.selectingAllProducts = true;
      });

      this.selectAllProducts = !this.selectAllProducts;
      this.filteredProducts.forEach((product) => {
        this.$set(product, 'checkbox', this.selectAllProducts);
      });

      this.$nextTick(() => {
        this.selectingAllProducts = false;
      });

      this.completeInfiniteLoading();
    },

    getCurrentStock(skuStocks) {
      return skuStocks.find((stock) => stock.store_id === this.store.id);
    },

    async addToCatalogue() {
      this.$nextTick(() => {
        this.addingProducts = true;
      });

      const productsFiltered = this.products.filter(
        (product) => product.checkbox && !this.getCatalogue.some((catalogue) => catalogue.id === Number(product.id)),
      ).map((product) => {
        const highestPriceSku = this.getHighestPrice(product);

        delete product.price;

        return {
          ...product,
          quantity: product.quantity || 1,
          warranty: null,
          price: highestPriceSku.sku_prices.length ? highestPriceSku.sku_prices[0].price : 0, // Os preços dentro do sku_prices já vem filtrado pela loja, então podemos assumir o índice 0 como o da loja em questão
          old_price: highestPriceSku.sku_prices.length ? highestPriceSku.sku_prices[0].old_price : 0,
          color: highestPriceSku.color,
          size: highestPriceSku.size,
          ean: highestPriceSku.ean,
          currentStock: this.getCurrentStock(highestPriceSku.sku_stocks) ? this.getCurrentStock(highestPriceSku.sku_stocks).stock : 0,
          sku_id: highestPriceSku.sku_id,
          store_id: highestPriceSku.sku_prices[0].store_id,
        };
      });

      this.$store.dispatch('setProducts', this.products.map((product) => ({ ...product, checkbox: false })));
      this.$store.dispatch('addProductsToCatalogue', productsFiltered);
      this.$nextTick(() => {
        this.addingProducts = false;
      });
      this.$router.push('/catalogo');
    },

    reset() {
      this.$refs.combobox.lazySearch = '';
      this.$refs.combobox.isMenuActive = false;
    },

    async infiniteHandler($state) {
      if (this.awaitingSearch) return;
      if (!this.templateCatalogue._id) await this.getTemplateCatalogue();
      if (!this.products.length) {
        this.products = this.getProducts;
        this.checkProducts(this.products);
        this.getFilters();
        $state.loaded();
        return;
      }

      if (this.slicedProducts.length < this.finalProducts.length) {
        this.page += 1;
        $state.loaded();
      } else {
        $state.complete();
      }
    },

    getFilters() {
      const skus = _.flatten(this.products.map((product) => product.skus));
      const filters = {
        sectors: this.searchSectors,
        categories: _.uniq(this.products.map((p) => p.categoria)).filter((p) => p),
        sizes: _.uniq(skus.map((s) => s.size)).filter((p) => p),
        colors: _.uniq(skus.map((s) => s.color)).filter((p) => p),
      };

      Object.entries(filters).forEach((filter) => {
        if (filter[1].length) {
          this.allFilters = this.allFilters
            .concat(this.searchHeaders[filter[0]])
            .concat(filter[1]);
        }
      });
      this.filters = filters;
    },

    async getCatalogueByType(type) {
      const res = await this.$apollo.query({
        query: FindCatalogueBySellerIdAndType,
        variables: {
          sellerId: this.$auth.user.sub,
          type,
        },
        fetchPolicy: 'no-cache',
      });
      this.eventCatalogue = res.data.catalogueBySellerIdAndType;
    },

    emitSnackbar(color, text) {
      const snackBar = {};
      snackBar.text = text;
      snackBar.value = true;
      snackBar.color = color;
      EventBus.$emit('activeSnackBar', snackBar);
    },

    resetInfiniteLoading() {
      this.$refs.infiniteLoading.stateChanger.reset();
    },

    completeInfiniteLoading() {
      this.$refs.infiniteLoading.stateChanger.loaded();
    },

    async getTemplateCatalogue() {
      if (this.isCatalogue) await this.getCatalogueBySeller();
      this.templateCatalogue = await client.chain.query
        .findTemplateCatalogueById({ templateCatalogueId: this.templateCatalogueId })
        .get({
          ...everything,
          corridors: {
            ...everything,
            priceRange: { ...everything, __typename: false },
            saleRange: { ...everything, __typename: false },
            __typename: false,
          },
        });
    },

    discountFilter(product, corridor) {
      if (
        !corridor.saleRange
        || (!corridor.saleRange.start && !corridor.saleRange.end)
      ) return true;
      const { start, end } = corridor.saleRange;
      const discount = Math.abs((product.price / product.oldPrice) - 1) * 100 || 0.0;
      return discount >= start && discount <= end;
    },

    priceFilter(product, corridor) {
      if (
        !corridor.priceRange
        || (!corridor.priceRange.start && !corridor.priceRange.end)
      ) return true;
      const { start, end } = corridor.priceRange;
      return product.price >= start && product.price <= end;
    },

    sizesFilter(product, corridor) {
      if (
        !corridor.sizes
        || !corridor.sizes.length
      ) return true;
      return corridor.sizes.includes(product.size);
    },

    filterProductsSkusByTemplateCatalogue(products) {
      return products.filter((product) => (
        product.skus.some((sku) => (
          this.templateCatalogue.corridors.some((corridor) => (
            this.priceFilter(sku, corridor)
              && this.discountFilter(sku, corridor)
              && this.sizesFilter(sku, corridor)
          ))
        ))
      ));
    },

    async getCatalogueBySeller() {
      this.catalogue = await client.chain.query
        .findCatalogueByIdAndSellerId({
          customerId: this.getCustomer.id,
          catalogueId: this.getCatalogueId,
          sellerId: this.$auth.user.sub,
        })
        .get({ ...everything });
    },

    addSkuPriceToProduct(cartProduct, product) {
      this.$set(product, 'price', cartProduct.price);
      this.$set(product, 'oldPrice', cartProduct.oldPrice);
    },

    checkProducts(products) {
      products.forEach((product) => {
        // eslint-disable-next-line no-param-reassign
        product.id = Number(product.id);

        const cartProduct = this.getCatalogue.find((item) => (
          (item.id === product.id)
            && (!this.getCustomer.salesAssistant || product.skus[0].sku_id === item.sku_id)
        ));
        const isSelected = !!(product.checkbox || cartProduct || (this.isCatalogue && this.catalogue.productIds.includes(product.id)));
        if (cartProduct && this.getCustomer.salesAssistant) this.addSkuPriceToProduct(cartProduct, product);
        this.$set(product, 'checkbox', isSelected);
      });
    },

    backToProducts() {
      if (!this.catalogueProductCount) this.$router.push('/produtos');
      this.discardDialog = true;
    },

    getSearchMap(products) {
      return products.map((product) => {
        const skus = product.skus.find((sku) => sku.ean);
        return `${product.descricaoCurta} ${product.cor} ${product.setor} ${product.categoria} ${skus.ean} ${skus.sku_id_erp} ${product.reference}`;
      });
    },

    handleSearch() {
      let filters = this.catalogueFilters;
      let { products } = this;
      const { sizes, sectors } = this.filters || {};
      const size = filters.find((filter) => sizes && sizes.includes(filter));
      const sector = filters.find((filter) => sectors && sectors.includes(filter));

      if (size) {
        const filteredProducts = this.products.filter((p) => (
          p.skus.some((sku) => (
            sku.size === size
            && sku.currentStock > 0
            && sku.idLoja === this.getStore.id
          ))
        ));
        filters = filters.filter((input) => !sizes.includes(input));
        products = filteredProducts;
      }

      if (sector) {
        const filteredProducts = products.filter((p) => p.setor === sector || p.customSector === sector);
        filters = filters.filter((input) => !sector.includes(input));
        products = filteredProducts;
      }

      let searchResults = products;
      filters = filters.join(' ').split(/\s+/).filter((f) => f);

      filters.forEach((filter) => {
        const search = Wade(this.getSearchMap(searchResults));
        searchResults = search(filter).map((sr) => searchResults[sr.index]);
      });

      this.searchProducts = searchResults;
      this.page = 0;
    },

    openZeroStockDialog(product) {
      this.zeroStockDialog = true;
      this.productSelected = product;
    },

    sortProductsBySkuPrice(products, isOrderAsc) {
      products.forEach((product) => {
        product.skus.forEach((sku) => {
          sku.sku_prices.sort((a, b) => a.price - b.price);
        });
      });

      if (isOrderAsc) {
        products.sort((a, b) => a.skus[0].sku_prices[0].price - b.skus[0].sku_prices[0].price);
      } else {
        products.sort((a, b) => b.skus[0].sku_prices[0].price - a.skus[0].sku_prices[0].price);
      }

      return products;
    },

    setProductVisible(index) {
      this.filteredProducts[index].visible = true;
    },

    changeQuantityZeroStock(quantity) {
      this.productSelected.quantity = quantity;
    },

    openCamera() {
      this.barCodeDialog = true;
    },

    closeCamera() {
      this.barCodeDialog = false;
      Quagga.stop();
    },
  },
};
</script>

<style scoped lang="scss">

.toolbar {
  position: sticky;
  top: 0;
  z-index: 2;
  padding-top: 60px;
}

.order-by {
  font-family: 'Nunito sans';
  font-style: normal;
  line-height: 14px;
  &__txt {
    font-weight: 300;
    font-size: 10px !important;
    white-space: nowrap;
  }
  &__arrows {
    font-weight: 1000;
    font-size: 16px;
  }
  &__select {
    font-family: 'Nunito sans';
    font-weight: 400;
    font-size: 10px;
  }
}

::v-deep .v-list__tile {
  border: 1px solid #F1F1F1;
  &__title {
    padding-left: 30px;
    font-size: 10px;
    font-family: 'Neue-Metana';
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    text-transform: lowercase;
  }
  &__title::first-letter {
    text-transform: uppercase;
  }
}

.catalogue-select {
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0em;
  &__copy-link {
    width: 85px;
    height: 26.5px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border-radius: 105px;
  }
  &__personalize {
    width: 134px;
    height: 32px;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    border-radius: 6px;
    color: white;
  }
  &__select {
    width: 90%;
  }
  &__catalogue-name {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 2.4vh;
    text-align: start;
  }
}

.black-circle {
  display: inline-block;
  background-color: #140C22;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.catalogue-product-count {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 42px;
  min-width: 42px;
  height: 42px;
  border-radius: 7px;
  cursor: pointer;
}

.change-route-btn {
  display: inline-block;
  width: auto;
  margin: 0 40px;
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 102%;
  text-transform: capitalize;
  border-radius: 20px;
}

.barcode {
    color: #140C22;
    width: 52px;
    height: 30px;
    font-weight: 500;
    text-align: center;
    border-radius: 6px;
    padding: 7px;
  }

  @media all and (min-width: 1200px)  {
  .barcode {
      display: none;
  }
  .search {
    width: 133.5%;
  }
  .order-by__select-btn {
    max-width: none;
    flex-basis: 69%;
  }

  .order-arrows {
    max-width: none;
    flex-basis: 10.333%;
  }

  .order-by__select-order {
    max-width: none;
    flex-basis: 20.667%;
  }
}
.navigation-toolbar {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 125px;
}

.progress-circular {
  height: 50vh !important;
}

::v-deep .v-subheader {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  color: #000;
  background-color: #F8F4F0;
  border-radius: 5px;
  height: 45.71px;
}

::v-deep .v-list {
  padding: 0;
}

::v-deep .v-select__slot {
  font-family: 'Neue-Metana';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 102%;
}

::v-deep .v-badge__badge {
  width: 18px;
  height: 18px;
}

::v-deep .v-btn {
  min-width: 0px;
}

@media all and (max-width: 860px)  {
  ::v-deep .v-chip__content {
  max-width: 170px;
  white-space: nowrap;
  }
}

::v-deep .v-chip__content {
  height: auto;
}

::v-deep .v-chip--removable .v-chip__content {
  white-space: normal;
}

::v-deep .v-chip--small {
  height: auto !important;
}
</style>
